// Module
var code = "<div ng-if=itemProperties class=\"banner-box [[itemProperties.cssClass]]\"> <div id=[[itemProperties.slotId]] class=banner> <div x-jr-dfp-script ng-if=itemProperties.slotId></div> </div> </div> ";
// Exports
module.exports = code;